import { useEffect, useState } from "react";
import {
	Box,
	Button,
	CircularProgress,
	Dialog,
	DialogActions,
	DialogContent,
	DialogTitle,
	Typography,
	useTheme,
} from "@mui/material";
import useStyles from "./styles";
import api from "../../../services/api";

export default function ModalDivergencia({ open, onClose, clienteId, chave, nomeCliente }) {
	const [carregando, setCarregando] = useState(true);
	const [divergencia, setDivergencia] = useState(null);
	const [erro, setErro] = useState(null);
	const theme = useTheme();
	const styles = useStyles(theme);

	// Busca a divergencia de itens entre a referencia central e o cliente, toda vez que o modal abre
	useEffect(() => {
		if (!open) return;
		buscarDivergencia();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [open, clienteId, chave]);

	// GET /versionamento/templates/divergencia - o model pode lancar erro em varios cenarios
	// (chave/cliente nao encontrado, falha de rede/API do Zabbix), sempre com mensagem legivel
	async function buscarDivergencia() {
		setCarregando(true);
		setErro(null);
		setDivergencia(null);
		try {
			const response = await api.get("/versionamento/templates/divergencia", {
				params: { clienteId, chave },
			});
			setDivergencia(response?.data || null);
		} catch (error) {
			setErro(
				error?.response?.data?.error ||
					"Não foi possível verificar a divergência deste cliente.",
			);
		} finally {
			setCarregando(false);
		}
	}

	const temExtras = (divergencia?.extrasNoCliente?.length || 0) > 0;

	return (
		<Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
			<DialogTitle>Divergência de template</DialogTitle>
			<DialogContent>
				<Typography variant="body2" sx={styles.subtitulo}>
					{nomeCliente} — {chave}
				</Typography>
				{carregando && (
					<Box sx={styles.loadingContainer}>
						<CircularProgress size={28} />
					</Box>
				)}
				{!carregando && erro && (
					<Typography variant="body2" sx={styles.erro}>
						{erro}
					</Typography>
				)}
				{!carregando && !erro && divergencia && (
					<Box sx={styles.listasContainer}>
						<Box sx={styles.blocoLista}>
							<Typography variant="subtitle2" sx={styles.tituloLista}>
								Faltando no cliente
							</Typography>
							<Typography variant="caption" sx={styles.textoExplicativo}>
								Itens que a referência tem e o cliente ainda não tem. A
								atualização instala esses itens — não bloqueia.
							</Typography>
							{divergencia?.faltandoNoCliente?.length > 0 ? (
								<Box component="ul" sx={styles.lista}>
									{divergencia.faltandoNoCliente.map((item) => (
										<Box component="li" key={item} sx={styles.itemLista}>
											{item}
										</Box>
									))}
								</Box>
							) : (
								<Typography variant="body2" sx={styles.semItens}>
									Nenhum item faltando.
								</Typography>
							)}
						</Box>
						<Box sx={temExtras ? styles.blocoAlerta : styles.blocoLista}>
							<Typography
								variant="subtitle2"
								sx={temExtras ? styles.textoAlerta : styles.tituloLista}
							>
								Existem só no cliente
							</Typography>
							{temExtras && (
								<Typography variant="body2" sx={styles.textoAlerta}>
									Isso bloqueia a atualização automática — é customização
									local que a atualização pode sobrescrever.
								</Typography>
							)}
							{divergencia?.extrasNoCliente?.length > 0 ? (
								<Box component="ul" sx={styles.lista}>
									{divergencia.extrasNoCliente.map((item) => (
										<Box component="li" key={item} sx={styles.itemListaAlerta}>
											{item}
										</Box>
									))}
								</Box>
							) : (
								<Typography variant="body2" sx={styles.semItens}>
									Nenhum item exclusivo do cliente.
								</Typography>
							)}
						</Box>
					</Box>
				)}
			</DialogContent>
			<DialogActions>
				<Button onClick={onClose}>Fechar</Button>
			</DialogActions>
		</Dialog>
	);
}
